import { gql } from '@apollo/client';

export default gql`
  mutation trackFacebookEvent($eventName: String!, $params: FacebookEventParams) {
    trackFacebookEvent(eventName: $eventName, params: $params)
  }
`;
